var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import classNames from "classnames";
import React, { useState } from "react";
import { RicosAlignmentContextProvider, RicosNodeContextProvider } from "./../../ricos-context";
import { ROOT } from "../dataHooks";
import collapsibleListStyles from "../statics/styles/collapsible-list-component.rtlignore.scss";
import { getAlignmentFromDirection } from "../utils";
import { CollapsibleListContextProvider } from "./collapsibleListContext";
const CollapsibleList = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  var _a, _b;
  const [expandedItemId, setExpandedItemId] = useState(void 0);
  const styles = collapsibleListStyles;
  const direction = ((_a = node.collapsibleListData) == null ? void 0 : _a.direction.toLowerCase()) || "ltr";
  const alignment = getAlignmentFromDirection(direction);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles[direction], styles.listDimensions), "data-hook": ROOT }, /* @__PURE__ */ React.createElement(RicosAlignmentContextProvider, { textAlignment: alignment }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(
    CollapsibleListContextProvider,
    {
      expandedItemId,
      setExpandedItemId
    },
    /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_b = node.nodes) != null ? _b : [] })
  )))));
};
const CollapsibleListRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(CollapsibleList, __spreadValues({ key: node.id, node }, props));
};
var collapsibleList_default = CollapsibleListRenderer;
export {
  collapsibleList_default as default
};
//# sourceMappingURL=collapsibleList.js.map

import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";